import { Injectable } from "@angular/core";
import { ColorThemeSwitcher, DEFAULT_GEOINFO_PRIMARY_COLOR } from "@geolib/geoappbase-client";


@Injectable({ providedIn: "root" })
export class AppColorThemeSwitcher {

    public constructor() {
        ColorThemeSwitcher.setPrimaryColor(DEFAULT_GEOINFO_PRIMARY_COLOR);
    }

}
